export default __webpack_public_path__ + "static/media/lionsSymbol206.32ce4d48.png";